export default __webpack_public_path__ + "static/media/about-img.a732ba26.png";